import { Outlet, useLocation } from "react-router-dom";
import Header from "../Header/Header";
import InputSection from "../InputSection/InputSection";

import ChatType from "./ChatType";
import styles from "./ChatSection.module.css";
import { useSelector } from "react-redux";
import Loader from "../Ui/Loader";

const ChatSection = () => {
  const location = useLocation();
  const isLoader = useSelector((state) => state.chat.isLoader);
  const pathname = location?.pathname || "";
  const isChatHiddenPath =
    pathname.startsWith("/home/courses") || pathname.startsWith("/home/videoslides");
  return (
    <div className={styles["chat-section-main"]}>
      <Header />
      <ChatType />
      {isLoader && <Loader />}
      <Outlet />
      {!isChatHiddenPath && <InputSection />}
      {!isChatHiddenPath && (
        <div className={styles["warning-text"]}>
          <p>Computers make mistakes too, so check important information.</p>
        </div>
      )}
    </div>
  );
};

export default ChatSection;
